export default __webpack_public_path__ + "static/6-7f51bec0157431da45db27e989b8176d.png";